import * as dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { jwtDecode } from 'jwt-decode';
import { eventBus } from '../../utils/common';
import storage from './storage';
import { MODAL_OPEN } from '../redux/actions/index';
import { store } from '../redux/store';
import { ModalExpiringSessionId } from '../../ui/atoms/Modals/ModalExpiringSession';
import auth from './auth';

dayjs.extend(duration);
export const AuthStorage = 'Auth';

export const cleanToken = () => {
  storage.clearKey(AuthStorage);
};

const errorStatement = (err = 'Generic error') => {
  // eslint-disable-next-line no-console
  console.error(
    'Something goes wrong refreshing the token, user must login again',
    err
  );
  cleanToken();
  eventBus.dispatch('logout');
  if (keepTokenAliveInterval) dismissKeepTokenAlive();
};

const isValidToken = ({ token } = {}, deltaMinutes = 10) => {
  const decoded = jwtDecode(token);
  const isValid = dayjs().unix() < Number(decoded?.exp) - deltaMinutes * 60;
  return isValid;
};

let keepTokenAliveInterval;
export const dismissKeepTokenAlive = () => clearTimeout(keepTokenAliveInterval);
const keepTokenAlive = (token) => {
  if (keepTokenAliveInterval) dismissKeepTokenAlive();
  const decoded = jwtDecode(token?.token);
  // console.log('Token expires in', Number(decoded?.exp) - dayjs().unix());
  // console.log('Refresh token in ', Number(decoded?.exp) - dayjs().unix() - 100);
  keepTokenAliveInterval = setTimeout(() => {
    const {
      app: { isActive },
    } = store?.getState() || {};
    // if user active, refresh token automatically
    if (isActive) {
      auth.refreshToken({}).then((res) => {
        const { data: { data = {} } = {} } = res;
        setToken(data);
      });
      // else show ModalExpiringSession
    } else store.dispatch({ type: MODAL_OPEN, id: ModalExpiringSessionId });
  }, (Number(decoded?.exp) - dayjs().unix() - 100) * 1000); // 100s before expiration
};

export const setToken = (value) => {
  try {
    const newValue = { ...value, timestamp: dayjs().valueOf() };
    storage.write(AuthStorage, newValue);
    keepTokenAlive(newValue);
  } catch (err) {
    errorStatement(err);
  }
};

// eslint-disable-next-line consistent-return
const validateToken = (token) => {
  if (typeof token === 'object' && token !== null) {
    if (isValidToken(token, 0)) return token;
  }
  errorStatement();
  return null;
};

// eslint-disable-next-line consistent-return
const getTokenFlow = (token, skipErr) => {
  try {
    if (token) return validateToken(token);
    if (!skipErr) errorStatement();
    return {};
  } catch (err) {
    errorStatement(err);
  }
};

export const getToken = (skipErr = false) =>
  getTokenFlow(storage.read(AuthStorage)?.value, skipErr);

export const initializeToken = () => {
  const token = getToken(true);
  if (token) {
    const { timestamp, token: accessToken } = token;
    if (timestamp && accessToken) {
      if (isValidToken(token, 0)) {
        keepTokenAlive(token);
      } else {
        errorStatement();
      }
    }
  } else {
    errorStatement();
  }
};
initializeToken();
